






















































































































import Vue from 'vue';
import moment from 'moment';
import {
  CloseFullscreenWrapper,
  FormValidation,
  DateFormat,
  DOBAllowedDates,
  OpenHelp,
} from '@/mixins';

import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';

import { DatePicker } from '@/components/form-components';

import { required } from 'vuelidate/lib/validators';
import { date, dateHelpers } from '@/validations';
import { dateFormat } from '@/constants';

import { api, MEMBER_API_SUB_URLS } from '@/api';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { ExtendMixins } from '@/services';
import { ForgotUsernameFormModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  confirmBeforeClose: boolean;
  showSuccessMessage: boolean;
  showErrorMessage: boolean;
  formValid: boolean;
  errorMessage: string;
  successMessage: string;
  formModel: ForgotUsernameFormModel;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  DateFormat,
  DOBAllowedDates,
  OpenHelp,
).extend({
  name: 'ForgotUsername',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      confirmBeforeClose: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      formValid: false,
      errorMessage: this.params.errorMessage,
      successMessage: this.params.successMessage,
      formModel: {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        selectAccountId: '',
      },
    };
  },
  beforeMount() {
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      dateOfBirth: {
        required,
        date,
        dateOfBirth(value): boolean {
          return dateHelpers.sameOrBeforeDate(moment().format(dateFormat))(
            value,
          );
        },
      },
      selectAccountId: {
        required,
      },
    },
  },
  computed: {
    // VALIDATION MESSAGES
    firstNameErrors(): string[] {
      const formField = 'formModel.firstName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_first-name_required',
            'global_form-error_first-name_required',
          ],
          'required',
        ),
      ]);
    },
    lastNameErrors(): string[] {
      const formField = 'formModel.lastName';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_last-name_required',
            'global_form-error_last-name_required',
          ],
          'required',
        ),
      ]);
    },
    dateOfBirthErrors(): string[] {
      const formField = 'formModel.dateOfBirth';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_dob_required',
            'global_form-error_dob_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_dob_date',
            'global_form-error_date_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_dob_invalid-dob',
            'global_form-error_dob_invalid',
          ],
          'dateOfBirth',
        ),
      ]);
    },
    selectAccountIdErrors(): string[] {
      const formField = 'formModel.selectAccountId';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'forgot-username_form-error_select-account-id_required',
            'global_form-error_select-account-id_required',
          ],
          'required',
        ),
      ]);
    },
  },
  methods: {
    deconstructDOB(): void {
      this.formModel.dateOfBirth = InputMaskTypes.date.deconstruct(
        this.formModel.dateOfBirth,
      );
    },
    goBack(): void {
      this.confirmBeforeClose = true;
      this.showErrorMessage = false;
      this.errorMessage = this.params.errorMessage;
    },
    submitForm(): void {
      this.isLoading = true;
      // REST-092
      api
        .post(`${MEMBER_API_SUB_URLS.users}/username`, this.formModel)
        .then(() => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.showSuccessMessage = true;

          // GTM Event - Forgot Username
          window.dataLayer.push({
            event: 'forgotUsername',
          });
        })
        .catch((error) => {
          this.confirmBeforeClose = false;
          this.isLoading = false;
          this.showErrorMessage = true;

          if (error[0] && error[0].code === '40103') {
            this.errorMessage = this.params.errorMessageNoEmail;
          }
        });
    },
    updateDOB(dob): void {
      this.formModel.dateOfBirth = this.formatDate(dob);
      this.triggerBlur('formModel.dateOfBirth');
      this.updateHasChanged();
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    DatePicker,
  },
});
